import './public-path';
import { createApp, App as VueApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import ElementPlus from "element-plus";
import 'element-plus/dist/index.css';
import "@hview/hview-style";
import hview from "@hview/hview-vue3";
// import VForm3 from 'vform3-builds';
// import 'vform3-builds/dist/designer.style.css'
import VForm3 from '../vform/dist/designer.umd.js';
import '../vform/dist/designer.style.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// @ts-ignore
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';

let app: VueApp<Element> | null = null;

function mount() {
    if (app) {
        return;
    }
    app = createApp(App)
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
        app.component(key, component)
    }
    app.use(ElementPlus)
    app.use(router).use(hview).use(ElementPlus, {
        locale: zhCn
    }).use(VForm3).mount('#qianliu-doctor-app');
}

function unmount() {
    app?.unmount();
    app = null;
}

(window as any).mount = mount;
(window as any).unmount = unmount;

if (!(window as any).__MICRO_APP_ENVIRONMENT__) {
    mount();
} else {
    // 兼容 micro-app 只执行脚本、未主动调用 window.mount 的情况
    mount();
    window.addEventListener('unmount', unmount);
}
